import React, { Component } from 'react';
import { Card, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../Helpers/fetcher.js";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { Notify } from "../../Helpers/notification.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';

class CallDetailRecords extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cdrList: [],
            mobileNumber: '',
            apiPath: props.app.apiPath,
            role: props.app.role,
            userId: props.app.userId,
            noDataDisplayMsg: '',
            startDate: '',
            endDate: '',
            sizePerPage: 10,
            currentPage: 1,
            totalRecords: 0,
            isLoading: false
        }
        document.title = 'Call Detail Records'
    }

    componentDidMount() {
        const savedSizePerPage = Cookies.get('callDetailRecordListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
    }

    setvalue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    fetchCdrData = (pageNo, sizePerPage) => {
        const { mobileNumber, startDate, endDate, role, userId, apiPath } = this.state;

        const sDate = startDate === "" ? "" : this.formatDate(startDate);
        const eDate = endDate === "" ? "" : this.formatDate(endDate);

        this.setState({ isLoading: true });

        const data = {
            bni: mobileNumber,
            pageNo,
            pageSize: sizePerPage,
            startDate: sDate,
            endDate: eDate,
        };

        if (this.props.app.isSubOrSuperAdmin) {
            data.userType = 'sadmin';
        } else {
            data.userType = 'user';
            data.userId = userId;
        }

        return Fetcher.post(`${apiPath}/api/obd/search/cdr`, {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(res => {
                this.setState({
                    cdrList: res.response,
                    totalRecords: res.totalRecords,
                    currentPage: pageNo,
                    noDataDisplayMsg: res.response.length === 0 ? 'No records found' : ''
                });
            })
            .catch(err => {
                console.log('Error in fetching call detail records: ', err);
                Notify.notify('Error in fetching call detail records');
            })
            .finally(() => this.setState({ isLoading: false }));
    }

    searchCdr = (e) => {
        e.preventDefault();
        const { startDate, endDate } = this.state;

        if (startDate !== "" && endDate !== "") {
            if (new Date(this.formatDate(startDate)) > new Date(this.formatDate(endDate))) {
                Notify.notify("Start date cannot be greater than end date.");
                return;
            }
        }

        this.fetchCdrData(1, this.state.sizePerPage);
    }

    handleStartDateChange = (date) => {
        this.setState({ startDate: date });
    };

    handleEndDateChange = (date) => {
        this.setState({ endDate: date });
    };

    handlePageChange = (page, sizePerPage) => {
        this.fetchCdrData(page, sizePerPage);
    }

    handleSizePerPageChange = (newSizePerPage) => {
        Cookies.set('callDetailRecordListsizePerPage', newSizePerPage);
        this.setState({ sizePerPage: newSizePerPage }, () => {
            this.fetchCdrData(1, newSizePerPage);
        });
    }

    handleTableChange = (type, { page, sizePerPage }) => {
        if (type === 'pagination') {
            this.fetchCdrData(page, sizePerPage);
        }
    }

    refreshPage = () => {
        this.setState({
            cdrList: [],
            mobileNumber: '',
            startDate: '',
            endDate: '',
            noDataDisplayMsg: '',
            totalRecords: 0,
            currentPage: 1
        });
    }

    render() {
        const { cdrList, sizePerPage, currentPage, totalRecords, isLoading, noDataDisplayMsg } = this.state;

        const columns = [
            { dataField: 'campId', text: 'Camp Id', sort: true, hidden: false },
            { dataField: 'cli', text: 'CLI', sort: false, hidden: false },
            { dataField: 'username', text: 'Username', sort: false, hidden: false },
            { dataField: 'start_time', text: 'Start Date', sort: false, hidden: false },
            { dataField: 'answer_time', text: 'Answer Date', sort: false, hidden: false },
            { dataField: 'end_time', text: 'End Date', sort: false, hidden: false },
            { dataField: 'answerStatus', text: 'Answer Status', sort: false, hidden: false },
            { dataField: 'billingduration', text: 'Billing Duration', sort: false, hidden: false }
        ];

        const records = Array.isArray(cdrList) ? cdrList.map((row) => ({
            id: row.id,
            campId: row.campId,
            cli: row.cli,
            username: row.username,
            start_time: row.startTime,
            answer_time: row.answerTime,
            end_time: row.endTime,
            answerStatus: row.answerStatus,
            billingduration: row.billingduration
        })) : [];

        const { SearchBar, ClearSearchButton } = Search;
        const { ExportCSVButton } = CSVExport;

        const paginationOption = {
            page: currentPage,
            sizePerPage,
            totalSize: totalRecords,
            sizePerPageList: [
                { text: '10', value: 10 },
                { text: '25', value: 25 },
                { text: '50', value: 50 },
                { text: '100', value: 100 }
            ],
            onPageChange: this.handlePageChange,
            onSizePerPageChange: this.handleSizePerPageChange,
            showTotal: true
        };

        return (
            <Card>
                <Card.Header>Call Detail Records</Card.Header>
                <Card.Body>
                    <div className="widget-list-table-cont">

                        <Form className="add-campaign-form" method='post' onSubmit={this.searchCdr}>
                            <Row>
                                <Col sm={4}>
                                    <Form.Group className="form-group col-md-6 float-left">
                                        <Form.Control required name="mobileNumber" type="number" placeholder="Mobile Number" onChange={e => this.setvalue(e)} value={this.state.mobileNumber} />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="form-group col-md-6 float-left">
                                        <DatePicker
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd"
                                            selected={this.state.startDate}
                                            onChange={this.handleStartDateChange}
                                            placeholderText="Start Date"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="form-group col-md-6 float-left">
                                        <DatePicker
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd"
                                            selected={this.state.endDate}
                                            onChange={this.handleEndDateChange}
                                            placeholderText="End Date"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2}>
                                    <Button variant="primary" type="submit">Search</Button>
                                </Col>
                            </Row>
                        </Form>
                        <br />

                        {isLoading ? (
                            <div className="text-center my-4">
                                <Spinner animation="border" variant="primary" />
                                <div className="mt-2">Loading...</div>
                            </div>
                        ) : (
                            <ToolkitProvider
                                keyField="id"
                                data={records}
                                columns={columns}
                                search
                                bootstrap4
                            >
                                {props => (
                                    <div>
                                        <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                        <ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
                                        <ExportCSVButton className="float-right export-csv btn-primary ml-2" {...props.csvProps}>Export to CSV</ExportCSVButton>
                                        <Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={this.refreshPage}>Refresh</Button>
                                        <hr />
                                        <BootstrapTable
                                            remote={{ pagination: true }}
                                            onTableChange={this.handleTableChange}
                                            pagination={paginationFactory(paginationOption)}
                                            bordered={true}
                                            striped={true}
                                            condensed
                                            wrapperClasses="table-responsive"
                                            classes="widgetlist-table"
                                            {...props.baseProps}
                                            noDataIndication={noDataDisplayMsg}
                                        />
                                    </div>
                                )}
                            </ToolkitProvider>
                        )}
                    </div>
                </Card.Body>
            </Card>
        );
    }
}

export default CallDetailRecords;
